import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { makeStyles, Typography } from '@material-ui/core';
import { ErrorOutlineOutlined } from '@material-ui/icons';
import clsx from 'clsx';
import { pxToRem } from '../../theme';
const useStyles = makeStyles((theme) => ({
    root: {
        background: 'none',
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 6,
        minHeight: 82,
        padding: theme.spacing(2),
        textAlign: 'left',
        width: '100%',
        '&.active': {
            borderWidth: 2,
        },
        '&.searching': {
            backgroundColor: '#e0eef9',
            borderColor: '#b3d5ef',
        },
        '&.examining': {
            backgroundColor: '#fff3e0',
            borderColor: '#ffE0b2',
        },
        '&.quality-review': {
            backgroundColor: '#e8f5e9',
            borderColor: '#c8e6c9',
        },
        '&.action-required': {
            backgroundColor: '#f6e3e2',
            borderColor: '#e8b9b6',
        },
    },
    heading: {
        alignItems: 'center',
        display: 'inline-flex',
        fontWeight: 500,
        lineHeight: pxToRem(18),
        marginBottom: theme.spacing(1),
    },
    icon: {
        color: '#9a0c05',
        position: 'absolute',
        width: 20,
    },
    value: {
        fontSize: pxToRem(20),
        fontWeight: 600,
    },
    withIcon: {
        marginLeft: `calc(20px + ${theme.spacing(0.5)}px)`,
    },
}));
/**
 * DashboardMetricCard component that displays a heading, status, and value.
 *
 * @param {boolean} props.active - Active status of the tile.
 * @param {string} props.heading - The heading text to display.
 * @param {string} [props.status='Information'] - The status text to display. Defaults to 'Information'.
 * @param {string} props.value - The value to display.
 * @param {() => void} [props.onClick] - Optional click handler function.
 *
 * @returns {JSX.Element} The rendered DataCard component.
 */
export function DashboardMetricCard({ active = false, dataTestId, heading, status = 'Information', value, onClick, }) {
    const classes = useStyles();
    const statusClassName = status.split(' ').join('-').toLowerCase();
    const hasAction = !!onClick;
    const actionRequired = status === 'Action Required';
    return (_jsxs("button", { className: clsx(classes.root, statusClassName, { active }), "data-testid": dataTestId || 'dashboard-metric-card', style: { cursor: hasAction ? 'pointer' : '' }, tabIndex: hasAction ? 0 : -1, onClick: onClick, children: [_jsxs(Typography, { className: classes.heading, variant: 'h6', children: [actionRequired && _jsx(ErrorOutlineOutlined, { className: classes.icon, color: 'error' }), _jsx("span", { className: actionRequired ? classes.withIcon : '', children: heading })] }), _jsx(Typography, { className: classes.value, component: 'p', children: value })] }));
}
